import { render, staticRenderFns } from "./TemplateCalendarioFestivos.vue?vue&type=template&id=0a4cf949&"
import script from "./TemplateCalendarioFestivos.vue?vue&type=script&lang=js&"
export * from "./TemplateCalendarioFestivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports